export default [
  // USERS
  {
    path: '/admin/usuarios',
    name: 'admin-users',
    component: () => import('@/views/admin/users/Users.vue'),
    meta: {
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Usuarios',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'manage',
    },
  },
  {
    path: '/admin/usuarios/crear',
    name: 'admin-create-users',
    component: () => import('@/views/admin/users/create/CreateUsers.vue'),
    meta: {
      pageTitle: 'Crear Usuario',
      breadcrumb: [
        {
          text: 'Usuarios',
        },
        {
          text: 'Crear Usuario',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/admin/usuarios/:id/detalle',
    name: 'admin-detail-users',
    component: () => import('@/views/admin/users/show/UserView.vue'),
    meta: {
      pageTitle: 'Detalle de Usuario',
      breadcrumb: [
        {
          text: 'Usuarios',
        },
        {
          text: 'Detalle',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },

  // CLINICAS
  {
    path: '/admin/clinicas',
    name: 'admin-clinics',
    component: () => import('@/views/admin/clinics/Clinics.vue'),
    meta: {
      pageTitle: 'Clínicas',
      breadcrumb: [
        {
          text: 'Clínicas',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/admin/clinicas/crear',
    name: 'admin-create-clinic',
    component: () => import('@/views/admin/clinics/create/CreateClinicCard.vue'),
    meta: {
      pageTitle: 'Crear Clínica',
      breadcrumb: [
        {
          text: 'Clínicas',
        },
        {
          text: 'Crear Clínica',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/admin/asignar-odontologos',
    name: 'admin-clinic-dentists',
    component: () => import('@/views/admin/clinic-dentists/create/ClinicDentist.vue'),
    meta: {
      pageTitle: 'Asignar odontólogo a clínica',
      breadcrumb: [
        {
          text: 'Clínicas',
        },
        {
          text: 'Asignar',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },

  // PEDIDOS
  {
    path: '/admin/pedidos',
    name: 'admin-orders',
    component: () => import('@/views/admin/orders/Orders.vue'),
    meta: {
      pageTitle: 'Pedidos',
      breadcrumb: [
        {
          text: 'Pedidos',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/admin/pedidos/crear',
    name: 'admin-create-order',
    component: () => import('@/views/admin/orders/create/CreateOrder.vue'),
    meta: {
      pageTitle: 'Crear pedido',
      breadcrumb: [
        {
          text: 'Pedidos',
        },
        {
          text: 'Crear Pedido',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },

  // PLANEACION DE ORDEN
  {
    path: '/admin/planificacion-de-ordenes',
    name: 'admin-planning-orders',
    component: () => import('@/views/admin/planning-orders/PlanningOrders.vue'),
    meta: {
      pageTitle: 'Planificación de pedidos',
      breadcrumb: [
        {
          text: 'Planificación',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/admin/planificacion-de-orden/:id',
    name: 'admin-planning-order-detail',
    component: () => import('@/views/admin/planning-orders/planning-view/PlanningsView.vue'),
    meta: {
      pageTitle: 'Planificación de pedido',
      breadcrumb: [
        {
          text: 'Planificación',
        },
        {
          text: 'Detalle',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/admin/pedido/remision/:id',
    name: 'admin-order-remission',
    component: () => import('@/views/admin/planning-orders/remission/RemissionPreview.vue'),
    meta: {
      pageTitle: 'Remisión',
      breadcrumb: [
        {
          text: 'Detalle',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },

  // FABRICACION
  {
    path: '/admin/fabricacion-de-ordenes',
    name: 'admin-manufacturing-orders',
    component: () => import('@/views/admin/manufacturing-orders/ManufacturingOrders.vue'),
    meta: {
      pageTitle: 'Fabricación de pedidos',
      breadcrumb: [
        {
          text: 'Fabricación',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/admin/fabricacion-de-orden/:id',
    name: 'admin-manufacturing-order-detail',
    component: () => import('@/views/admin/manufacturing-orders/manufacturing-view/ManufacturingView.vue'),
    meta: {
      pageTitle: 'Fabricación de pedido',
      breadcrumb: [
        {
          text: 'Fabricación',
        },
        {
          text: 'Detalle',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },

  // PAYMENT
  {
    path: '/admin/checkout/:id/:payment_type',
    name: 'admin-checkout',
    component: () => import('@/views/admin/payment/ECommerceCheckout.vue'),
    meta: {
      pageTitle: 'Pagos',
      breadcrumb: [
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/admin/checkout/:id/:fabrication/:payment_type',
    name: 'admin-checkout-aligners',
    component: () => import('@/views/admin/payment/ECommerceCheckout.vue'),
    meta: {
      pageTitle: 'Pagos',
      breadcrumb: [
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/admin/checkout-response/:reference',
    name: 'admin-checkout-response',
    component: () => import('@/views/admin/payment/ResponseCheckout.vue'),
    meta: {
      pageTitle: 'Pagos',
      breadcrumb: [
      ],
      resource: 'ACL',
      action: 'read',
    },
  },

  // SCHEDULES
  {
    path: '/admin/agendas',
    name: 'admin-schedule-list',
    component: () => import('@/views/admin/schedules/manage/Schedules.vue'),
    meta: {
      pageTitle: 'Agenda',
      breadcrumb: [
      ],
      resource: 'ACL',
      action: 'read',
    },
  },

]
